// extracted by mini-css-extract-plugin
export default {"color":"color___LNkJE"};